<template>
  <div class="view-product-index">
    <div class="d-flex justify-content-between align-items-center mb-6">
      <tabs
        v-model="tab"
        :tabs="[
          { id: 'producer', name: 'Sou Produtor (a)' },
          { id: 'coproducer', name: 'Sou Coprodutor (a)' }
        ]"
      />
      <display-switch />
    </div>

    <producer-products v-show="tab === 'producer'" />
    <coproducer-products v-show="tab === 'coproducer'" />
  </div>
</template>

<script>
import CoproducerProducts from "@/components/product/index/CoproducerProducts.vue";
import DisplaySwitch from "@/components/product/index/DisplaySwitch.vue";
import ProducerProducts from "@/components/product/index/ProducerProducts.vue";
import Tabs from "@/components/Tabs.vue";

export default {
  components: { ProducerProducts, CoproducerProducts, DisplaySwitch, Tabs },
  data() {
    const productsView = localStorage.getItem("productsView") || "producer";
    return {
      tab: productsView
    };
  },
  methods: {
    changeTab(v) {
      localStorage.setItem("productsView", v);
    }
  }
};
</script>
